import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// react components for routing our app without refresh
import { Link } from 'react-router-dom';
// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

import examplesStyle from 'assets/jss/material-kit-pro-react/views/presentationSections/examplesStyle.jsx';
import imagesStyles from 'assets/jss/material-kit-pro-react/imagesStyles.jsx';

import exAboutUs from 'assets/img/assets-for-demo/example-pages/ex-about-us.jpg';
import exLanding from 'assets/img/assets-for-demo/example-pages/ex-landing.jpg';
import exContact from 'assets/img/assets-for-demo/example-pages/ex-contact.jpg';
import exBlogPost from 'assets/img/assets-for-demo/example-pages/ex-blog-post.jpg';
import exProductPage from 'assets/img/assets-for-demo/example-pages/ex-product.jpg';
import exLoginPage from 'assets/img/assets-for-demo/example-pages/ex-login.jpg';
import exPricing from 'assets/img/assets-for-demo/example-pages/ex-pricing.jpg';
import exSignup from 'assets/img/assets-for-demo/example-pages/ex-register.jpg';
import exProfile from 'assets/img/assets-for-demo/example-pages/ex-profile.jpg';
import exBlog from 'assets/img/assets-for-demo/example-pages/ex-blog-posts.jpg';
import EventGallery from '../EventGallery';

const styles = {
  ...examplesStyle,
  ...imagesStyles,
};

class SectionExamples extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classNames(classes.section, classes.sectionDark)}>
        <div className={classes.container}>
          <GridItem
            md={8}
            className={classNames(classes.mrAuto, classes.mlAuto)}
          >
            <div
              style={{ marginBottom: 0 }}
              className={classes.sectionDescription}
            >
              <h2 id="specialEvents" className={classes.title}>
                Special events
              </h2>
              <h5 className={classes.description}>
                These are special Yoga programmes that take place live at a
                certain time.
              </h5>
            </div>
          </GridItem>
          {/* <EventGallery /> */}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(SectionExamples);



// WEBPACK FOOTER //
// ./src/views/YogaPage/Sections/SectionExamples.jsx